<script setup lang="ts">
  import { Text } from "@ui-kit";

  const { countGoods, countCollectedGoods } = defineProps<{
    countGoods: number;
    countCollectedGoods: number;
  }>();
</script>

<template>
  <div
    class="order-collected-progress"
    :class="{ 'completed': countGoods > 0 && countGoods === countCollectedGoods }"
    data-testid="order-collected-progress"
  >
    <div class="item">
      <Text font="heading-H4">{{ countGoods }}</Text>
      <Text font="body-regular-12" color="secondary">{{ $t("к сборке") }}</Text>
    </div>
    <div class="item">
      <Text font="heading-H4">{{ countCollectedGoods }}</Text>
      <Text font="body-regular-12" color="secondary">{{ $t("собрано") }}</Text>
    </div>
  </div>
</template>

<style scoped>
  .order-collected-progress {
    display: flex;
    background-color: var(--sf-base-background-primary);
    border-radius: 12px;
    padding: 2px 0 6px;
    margin-top: 8px;

    &.completed {
      background-color: var(--sf-size-background-success-default);

      & :deep(.text) {
        color: var(--sf-size-text-success);
      }
    }

    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 1;

      & :deep(.text:last-of-type) {
        margin-top: -4px;
      }
    }
  }
</style>
